module.exports = __webpack_public_path__ + "static/devoxx-0e6499aabd8f2f34988ba74df2d6e327.png";